(() => {
  angular
    .module('revenue')
    .controller('revenue.views.corporateSubscriptions.create', CreateSubscriptionsController);

  CreateSubscriptionsController.$inject = [
    '$state',
    '$scope',
    '$stateParams',
    'abp.services.revenue.subscription',
    'abp.services.revenue.subscriptionPlan',
    'abp.services.revenue.common',
    'abp.services.revenue.settings',
    '$uibModal',
    'HmsRevenueConsts.SubscriptionPlan',
    'Hms.Revenue.AgentType',
    'Hms.Revenue.SubscriptionPlanCategory',
    'Hms.Revenue.SubscriptionPlanPricingMode',
    'Hms.Revenue.SubscriptionPlanChargeMode',
    'Hms.Revenue.SubscriptionBillingMode',
    'Hms.Revenue.SubscriptionScope',
    'Hms.Revenue.SubscriptionBillTo',
    'Hms.Revenue.OutpatientServiceFeatures',
    'Hms.Revenue.InpatientServiceFeatures',
  ];

  function CreateSubscriptionsController(
    $state,
    $scope,
    $stateParams,
    subscriptionSvc,
    subscriptionPlanSvc,
    revenueCommonSvc,
    settingsSvc,
    $uibModal,
    constsSubscriptionPlan,
    agentTypeEnum,
    enumSubscriptionPlanCategory,
    enumSubscriptionPlanPricingMode,
    enumSubscriptionPlanChargeMode,
    enumSubscriptionBillingMode,
    enumSubscriptionScope,
    enumSubscriptionBillTo,
    enumOutpatientServiceFeatures,
    enumInpatientServiceFeatures
  ) {
    const vm = this;

    vm.loading = 0;
    vm.corporateId = $stateParams.corporateId;
    vm.enums = {};
    vm.constsSubscriptionPlan = constsSubscriptionPlan;
    vm.categoryCharges = [];
    vm.currencyCode = 'MYR';
    vm.subsidiaries = [];
    vm.subscriptionPlans = [];
    vm.subscriptionPlanId = null;
    vm.disablePrepaid = false;
    vm.subscriptions = [];
    vm.headcountDict = {};
    vm.initialChargeableHeadcountDict = {};
    vm.selectedSubsidiaries = [];

    vm.hasShortfallChargesEnhancement = false;

    vm.enums = {
      subscriptionPlanCategory: enumSubscriptionPlanCategory,
      subscriptionPlanPricingMode: enumSubscriptionPlanPricingMode,
      subscriptionPlanChargeMode: enumSubscriptionPlanChargeMode,
      subscriptionBillingMode: enumSubscriptionBillingMode,
      subscriptionScope: enumSubscriptionScope,
      subscriptionBillTo: enumSubscriptionBillTo,
      outpatientServiceFeatures: enumOutpatientServiceFeatures,
      inpatientServiceFeatures: enumInpatientServiceFeatures,
    };

    vm.serviceFeatures = _.union(
      vm.enums.outpatientServiceFeatures.values,
      vm.enums.inpatientServiceFeatures.values
    );

    vm.subscription = {
      id: null,
      name: '',
      corporateId: $stateParams.corporateId,
      scope: null,
      subsidiaryIds: [],
      subsidiaryNames: [],
      isTargetAccount: null,
      billingAccountId: null,
      billingAccountName: '',
      effectiveStartDate: null,
      effectiveEndDate: null,
      subscriptionPlanId: null,
      billingFrequency: null,
      chargeMode: 0,
      pricingMode: 0,
      salesPersonId: null,
      salesPersonName: '',
      introducerId: null,
      introducerName: '',
      categoryCharges: [],
    };

    vm.subscriptionPlan = {
      planName: null,
      planCategory: null,
      pricingMode: null,
      chargeMode: null,
      effectiveDate: null,
    };

    vm.salesPersonLookup = {
      cachedResults: [],
      activeResults: [],
      lastSearchKey: '',
      lookup(search) {
        this.lastSearchKey = (search || '').trim().toLowerCase();
        const cachedCopy = this.cachedResults[this.lastSearchKey];
        if (cachedCopy) {
          this.activeResults = cachedCopy;
        } else {
          const mgr = this;
          const salesType = [];

          salesType.push(agentTypeEnum.SalesPerson.id);
          salesType.push(agentTypeEnum.CustomerSuccess.id);

          revenueCommonSvc
            .findAgents({
              filter: this.lastSearchKey,
              maxResultCount: 100,
              types: salesType,
              activeOnly: true,
            })
            .success((data) => {
              const dataKey = (data.filter || '').trim().toLowerCase();
              mgr.cachedResults[dataKey] = data.items;
              if (dataKey === mgr.lastSearchKey) {
                mgr.activeResults = data.items;
              }
            });
        }
      },
    };

    vm.introducerLookup = {
      cachedResults: [],
      activeResults: [],
      lastSearchKey: '',
      lookup(search) {
        this.lastSearchKey = (search || '').trim().toLowerCase();
        const cachedCopy = this.cachedResults[this.lastSearchKey];
        if (cachedCopy) {
          this.activeResults = cachedCopy;
        } else {
          const mgr = this;
          const salesType = [];

          salesType.push(agentTypeEnum.Introducer.id);

          revenueCommonSvc
            .findAgents({
              filter: this.lastSearchKey,
              maxResultCount: 100,
              types: salesType,
              activeOnly: true,
            })
            .success((data) => {
              const dataKey = (data.filter || '').trim().toLowerCase();
              mgr.cachedResults[dataKey] = data.items;
              if (dataKey === mgr.lastSearchKey) {
                mgr.activeResults = data.items;
              }
            });
        }
      },
    };

    vm.getSubscriptionPlan = getSubscriptionPlan;
    vm.getServiceFeaturesAsString = getServiceFeaturesAsString;
    vm.getSubscriptionPlanCategory = getSubscriptionPlanCategory;
    vm.getChargeMode = getChargeMode;
    vm.getPricingMode = getPricingMode;
    vm.refreshFields = refreshFields;
    vm.save = save;
    vm.getSelectedSubsidiaries = getSelectedSubsidiaries;
    vm.getSubsidiaryName = getSubsidiaryName;
    vm.getInitialHeadcount = getInitialHeadcount;
    vm.minusOneDay = minusOneDay;
    vm.getFormattedHeadcountData = getFormattedHeadcountData;
    vm.anyMinimumHeadcountFilled = anyMinimumHeadcountFilled;

    init();

    function init() {
      settingsSvc
        .getSetting({
          settingName: 'ShortfallChargesEnhancement',
        })
        .success((data) => {
          vm.hasShortfallChargesEnhancement = data;
        });
      loadSubscriptionOptions();
      getSubscriptionPlansDropdown();
      vm.salesPersonLookup.lookup();
      vm.introducerLookup.lookup();
    }

    function getSubscriptionPlansDropdown() {
      subscriptionPlanSvc
        .getSubscriptionPlansDropdown({
          corporateId: vm.corporateId,
        })
        .success((data) => {
          vm.subscriptionPlans = data.items;
        });
    }

    function getSubscriptionPlan() {
      vm.loading += 1;
      if (vm.subscriptionPlanId) {
        subscriptionPlanSvc
          .getSubscriptionPlan({
            id: vm.subscriptionPlanId,
          })
          .success((data) => {
            vm.subscriptionPlan = data;
            vm.currencyCode = vm.subscriptionPlan.currencyCode;
            vm.categoryCharges = vm.subscriptionPlan.categoryCharges;

            // Disable prepaid for per ticket and per case basis.

            vm.disablePrepaid =
              vm.subscriptionPlan.pricingMode === 2 || vm.subscriptionPlan.pricingMode === 3;

            vm.subscriptionPlan.categoryCharges.forEach((cc, i) => {
              cc.id = cc.id || i + 1;
              vm.getInitialHeadcount(i + 1);
            });
          })
          .finally(() => {
            vm.loading -= 1;
          });
      } else {
        vm.subscriptionPlan = null;
        vm.currencyCode = '';
        vm.categoryCharges = [];
        vm.loading -= 1;
      }
    }

    function loadSubscriptionOptions() {
      vm.loading += 1;
      subscriptionSvc
        .getCreateSubscriptionOptions({
          corporateId: vm.corporateId,
        })
        .success((data) => {
          vm.corporate = {
            code: data.corporateCode,
            name: data.corporateName,
          };
          vm.subsidiaries = data.subsidiaries;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function validateForm() {
      const form = $scope.editForm;
      return App.isFormValid(form);
    }

    function save() {
      if (vm.loading) return;

      if (vm.subscription.effectiveStartDate > vm.subscription.effectiveEndDate) {
        abp.message.error(App.localize('SubscriptionEffectiveEndDateEarlierThanStartDate'));
        return;
      }

      if (!validateForm()) {
        abp.message.warn(App.localize('OneOrMoreInputValueIsInvalid'));
        return;
      }

      vm.subscriptions.length = 0;
      removeDeselectedSubsidiaryHeadcounts();

      if (vm.subscription.salesPersonId) {
        vm.subscription.salesPersonName = vm.salesPersonLookup.activeResults.find(
          (x) => x.value === vm.subscription.salesPersonId
        ).name;
      }

      if (vm.subscription.introducerId) {
        vm.subscription.introducerName = vm.introducerLookup.activeResults.find(
          (x) => x.value === vm.subscription.introducerId
        ).name;
      }

      if (
        vm.subscription.subsidiaryIds.length > 0 &&
        vm.subscription.scope === vm.enums.subscriptionScope.Subsidiary.id &&
        vm.subscription.billTo === vm.enums.subscriptionBillTo.IndividualBillingAccount.id
      ) {
        let index = 0;

        vm.subscription.subsidiaryIds.forEach((subsidiaryId) => {
          let subscription = JSON.parse(JSON.stringify(vm.subscription));

          subscription.pricingMode = vm.subscriptionPlan.pricingMode;
          subscription.isTargetAccount =
            vm.subscription.billTo === vm.enums.subscriptionBillTo.TargetBillingAccount.id;
          subscription.subscriptionPlanId = vm.subscriptionPlanId;
          subscription.id = index + 1;
          subscription.name = `Subscription ${index + 1}`;
          subscription.subsidiaryNames = [
            vm.subsidiaries.find((x) => x.value === subsidiaryId).name,
          ];
          subscription.subsidiaryIds = [subsidiaryId];

          // Taking subsidiaryId for now until finance billing account is fully implemented.

          subscription.billingAccountId = subsidiaryId;
          subscription.billingAccountName = vm.subsidiaries.find(
            (x) => x.value === subsidiaryId
          ).name;
          subscription.headcounts = vm.getFormattedHeadcountData();
          if (subscription.shortfallBillingAccountId) {
            subscription.shortfallBillingAccountName = vm.subsidiaries.find(
              (x) => x.value === subscription.shortfallBillingAccountId
            ).name;
          }

          vm.subscriptions.push(subscription);
          index += 1;
          subscription = {};
        });
      } else {
        const subscription = JSON.parse(JSON.stringify(vm.subscription));

        subscription.pricingMode = vm.subscriptionPlan.pricingMode;
        subscription.isTargetAccount =
          vm.subscription.billTo === vm.enums.subscriptionBillTo.TargetBillingAccount.id;
        subscription.subscriptionPlanId = vm.subscriptionPlanId;
        subscription.id = 1;
        subscription.name = `Subscription 1`;
        subscription.billingAccountId = vm.subscription.billingAccountId;
        subscription.billingAccountName = vm.subsidiaries.find(
          (x) => x.value === vm.subscription.billingAccountId
        ).name;

        if (
          vm.subscription.scope === vm.enums.subscriptionScope.Subsidiary.id &&
          vm.subscription.billTo === vm.enums.subscriptionBillTo.TargetBillingAccount.id
        ) {
          vm.subscription.subsidiaryIds.forEach((subsidiaryId) => {
            subscription.subsidiaryNames.push(
              vm.subsidiaries.find((x) => x.value === subsidiaryId).name
            );
          });
        }

        vm.subscriptions.push(subscription);
      }

      _.forEach(vm.categoryCharges, (item) => {
        item.subscriptionPlanTierId = item.latestRetailPrice.subscriptionPlanTierId;
        item.retailPrice = item.latestRetailPrice.chargeAmount;

        // Without the enhancement the user types the total straight into the category charge.
        if (vm.hasShortfallChargesEnhancement) {
          // Only selected subsidiaries count; deselected ones may still hold a typed value.
          const headcount = vm.initialChargeableHeadcountDict[item.id]?.headcount ?? {};
          item.initialChargeableHeadcount = vm.subscription.subsidiaryIds.reduce(
            (sum, id) => sum + (headcount[id] ?? 0),
            0
          );
        }
      });

      showConfirmationModal();
    }

    function showConfirmationModal() {
      const modal = $uibModal.open({
        templateUrl: require('../confirmation/confirmation.modal.html'),
        controller: 'revenue.views.subscriptions.create.confirmationModal as vm',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          subscriptions() {
            return vm.subscriptions;
          },
          subscriptionPlan() {
            return vm.subscriptionPlan;
          },
          categoryCharges() {
            return vm.categoryCharges;
          },
          currencyCode() {
            return vm.currencyCode;
          },
          initialChargeableHeadcountDict() {
            return vm.initialChargeableHeadcountDict;
          },
          hasShortfallChargesEnhancement() {
            return vm.hasShortfallChargesEnhancement;
          },
        },
      });
      modal.result.then(() => {
        vm.loading += 1;

        subscriptionSvc
          .createSubscriptions({
            subscriptions: vm.subscriptions,
            categoryCharges: vm.categoryCharges,
            currencyCode: vm.currencyCode,
          })
          .success(() => {
            abp.notify.info(App.localize('SuccessfullySaved'));
            $state.go('revenue.corporates', {
              corporateId: vm.corporateId,
              section: 'newSubscriptions',
            });
          })
          .finally(() => {
            vm.loading -= 1;
          });
      });
    }

    function getServiceFeaturesAsString(serviceFeaturesArray) {
      const values = [];
      _.forEach(serviceFeaturesArray, (item) => {
        const serviceFeature = _.find(vm.serviceFeatures, (i) => i.id === item);
        values.push(serviceFeature.name);
      });
      return values.join(', ');
    }

    function getSubscriptionPlanCategory(planCategory) {
      if (planCategory === vm.enums.subscriptionPlanCategory.Outpatient.id) {
        return App.localize('OutpatientServices');
      }
      if (planCategory === vm.enums.subscriptionPlanCategory.Inpatient.id) {
        return App.localize('InpatientServices');
      }
      if (planCategory === vm.enums.subscriptionPlanCategory.Adhoc.id) {
        return App.localize('Adhoc');
      }
      return '';
    }

    function getChargeMode(chargeMode) {
      if (chargeMode === vm.enums.subscriptionPlanChargeMode.Monthly.id) {
        return App.localize('Monthly');
      }
      if (chargeMode === vm.enums.subscriptionPlanChargeMode.Yearly.id) {
        return App.localize('Yearly');
      }
      return '';
    }

    function getPricingMode(pricingMode) {
      if (pricingMode === vm.enums.subscriptionPlanPricingMode.Fixed.id) {
        return App.localize('Fixed');
      }
      if (pricingMode === vm.enums.subscriptionPlanPricingMode.PerMember.id) {
        return App.localize('PerMember');
      }
      if (pricingMode === vm.enums.subscriptionPlanPricingMode.PerTicketBasis.id) {
        return App.localize('PerTicketBasis');
      }
      if (pricingMode === vm.enums.subscriptionPlanPricingMode.PerCaseBasis.id) {
        return App.localize('PerCaseBasis');
      }
      return '';
    }

    function refreshFields() {
      if (vm.subscription.scope === vm.enums.subscriptionScope.Corporate.id) {
        vm.subscription.subsidiaryIds = [];
        vm.subscription.billTo = null;
        vm.subscription.billingAccountId = null;

        // Reload so the headcount table lists every subsidiary again.
        if (vm.subscriptionPlan?.categoryCharges) {
          vm.subscriptionPlan.categoryCharges.forEach((cc, i) => vm.getInitialHeadcount(i + 1));
        }
      }
    }

    function removeDeselectedSubsidiaryHeadcounts() {
      angular.forEach(vm.initialChargeableHeadcountDict, (data) => {
        Object.keys(data.headcount ?? {}).forEach((subsidiaryId) => {
          if (!vm.subscription.subsidiaryIds.includes(subsidiaryId)) {
            delete data.headcount[subsidiaryId];
          }
        });
      });
    }

    function getSelectedSubsidiaries() {
      vm.selectedSubsidiaries = [];
      vm.subscription.subsidiaryIds.forEach((subsidiaryId) => {
        const subsidiary = vm.subsidiaries.find((x) => x.value === subsidiaryId);
        vm.selectedSubsidiaries.push(subsidiary);
      });
    }

    function getSubsidiaryName(subsidiaryId) {
      return vm.subsidiaries.find((x) => x.value === subsidiaryId).name;
    }

    function getInitialHeadcount(index) {
      if (!vm.hasShortfallChargesEnhancement) return;

      subscriptionSvc
        .getInitialChargeableHeadcount({
          corporateCode: vm.corporate.code,
          subsidiaryIds: vm.subscription.subsidiaryIds,
          effectiveStartDate: vm.subscription.effectiveStartDate,
          subscriptionPricingTierId: index,
        })
        .success((data) => {
          vm.headcountDict[index] = data;

          if (vm.subscription.subsidiaryIds.length === 0) {
            vm.subscription.subsidiaryIds = Object.keys(vm.headcountDict[index].headcount);
          }

          vm.getSelectedSubsidiaries();
        });
    }

    function minusOneDay(dateStr) {
      const date = new Date(dateStr);
      date.setDate(date.getDate() - 1);
      return date;
    }

    function getFormattedHeadcountData() {
      const result = [];

      angular.forEach(vm.initialChargeableHeadcountDict, (data, categoryIndex) => {
        const headcounts = [];

        angular.forEach(data.headcount, (count, subsidiaryId) => {
          headcounts.push({
            subsidiaryId,
            count: count ?? 0,
          });
        });

        result.push({
          categoryChargeIndex: parseInt(categoryIndex, 10),
          headcounts,
        });
      });

      return result;
    }

    function anyMinimumHeadcountFilled() {
      return (
        vm.subscriptionPlan.categoryCharges &&
        vm.subscriptionPlan.categoryCharges.some(
          (item) =>
            item.minimumHeadcount !== null &&
            item.minimumHeadcount !== undefined &&
            item.minimumHeadcount !== 0
        )
      );
    }
  }
})();
